import {defineStore} from 'pinia';

export const useLivewireManager = defineStore('livewireManager', {
    state: () => ({
        componentId: null,
    }),
    actions: {
        register(componentId) {
            this.componentId = componentId;
        },
        getComponent() {
            // In Livewire v3, we can access the component through the $wire property
            // This store is used in Vue components that have access to Livewire
            if (this.componentId && window.Livewire) {
                // Try to find the component by ID in the current page
                const components = document.querySelectorAll('[wire\\:id]');
                for (const component of components) {
                    if (component.getAttribute('wire:id') === this.componentId) {
                        return component.__livewire;
                    }
                }
                
                // Alternative: try to find by component name if ID doesn't work
                if (window.Livewire.components) {
                    return window.Livewire.components.find(this.componentId);
                }
            }
            return null;
        },
        async renderMessage(message){
            const component = this.getComponent();
            if (component && typeof component.call === 'function') {
                return await component.call('renderMessage', message ?? '');
            }
            console.warn('Livewire component not found or call method not available');
            return null;
        }
    },
});
